import { Injectable } from '@angular/core';

export interface GtmEvent {
  event: string;
  [key: string]: unknown;
}

type WindowWithDataLayer = Window & {
  dataLayer: Array<Record<string, unknown>>;
};

@Injectable({ providedIn: 'root' })
export class GtmService {
  private get w(): WindowWithDataLayer {
    const w = window as unknown as WindowWithDataLayer;
    w.dataLayer = w.dataLayer || [];
    return w;
  }

  private push(data: GtmEvent): void {
    this.w.dataLayer.push(data);
  }

  pushLoginEvent(): void {
    this.push({'event': 'login'});
  }
}
